import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { api } from "../lib/api";
import { PageLoader } from "../components/shared";

const AuthCtx = createContext(null);
export const homeFor = (role) => ({ admin: "/admin", business: "/business", user: "/app" }[role] || "/");

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const refresh = useCallback(async () => {
    try {
      const r = await api.get("/auth/me");
      setUser(r.data);
      return r.data;
    } catch (e) {
      setUser(false);
      return false;
    }
  }, []);
  useEffect(() => {
    // Returning from Google: GoogleCallback exchanges session_id first, then sets the user.
    if (window.location.hash?.includes("session_id=")) { setUser(false); return; }
    refresh();
  }, [refresh]);
  const logout = async () => {
    await api.post("/auth/logout").catch(() => {});
    setUser(false);
  };
  return <AuthCtx.Provider value={{ user, setUser, refresh, logout }}>{children}</AuthCtx.Provider>;
}

export const useAuth = () => useContext(AuthCtx);

export function RequireRole({ roles, children }) {
  const { user } = useAuth();
  const loc = useLocation();
  if (user === null) return <PageLoader />;
  if (!user) return <Navigate to="/login" state={{ from: loc.pathname }} replace />;
  if (!roles.includes(user.role)) return <Navigate to={homeFor(user.role)} replace />;
  if (user.role !== "admin" && !user.email_verified) return <Navigate to="/confirm-email" replace />;
  return children;
}
